import { render, staticRenderFns } from "./invoiceTask.vue?vue&type=template&id=2467dc02&scoped=true&"
import script from "./invoiceTask.vue?vue&type=script&lang=js&"
export * from "./invoiceTask.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTask.vue?vue&type=style&index=0&id=2467dc02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467dc02",
  null
  
)

export default component.exports